import { User } from '../../domain/entities/User';
import { UserRepository } from '../../domain/repositories/UserRepository';

export class CGUAcceptanceService {
  constructor(private userRepository: UserRepository) {}

  async hasAccepted(user: User): Promise<boolean> {
    try {
      // Get fresh user data from Firebase to ensure we have the latest CGU status
      const freshUser = await this.userRepository.getUser(user.uid);
      return freshUser.hasCguAccepted();
    } catch (error) {
      console.error('Error checking CGU acceptance from Firebase:', error);
      // Fallback to user object data if Firebase call fails
      return user.hasCguAccepted();
    }
  }

  async acceptCGU(user: User): Promise<User> {
    try {
      // Create updated user with CGU acceptance
      const updatedUser = user.acceptCgu();
      
      // Save to Firebase
      const savedUser = await this.userRepository.updateCGUAcceptanceUser(updatedUser);
      
      return savedUser;
    } catch (error) {
      console.error('Error saving CGU acceptance to Firebase:', error);
      throw new Error('Failed to save CGU acceptance');
    }
  }

  async getAcceptanceDate(user: User): Promise<Date | null> {
    try {
      // Get fresh user data from Firebase
      const freshUser = await this.userRepository.getUser(user.uid);
      return freshUser.cguAcceptedAt;
    } catch (error) {
      console.error('Error getting CGU acceptance date from Firebase:', error);
      // Fallback to user object data
      return user.cguAcceptedAt;
    }
  }

  async refreshUserCGUStatus(user: User): Promise<User> {
    try {
      // Get fresh user data from Firebase with updated CGU status
      return await this.userRepository.getUser(user.uid);
    } catch (error) {
      console.error('Error refreshing user CGU status:', error);
      return user; // Return existing user if refresh fails
    }
  }
}